import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import MandatoryField from 'modules/_shared/components/MandatoryField';

import { useEditTradingOfferOperationStatusModal } from '../context/EditTradingOfferOperationStatusModalContext';

const EditTradingOfferOperationStatusModalBody: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useEditTradingOfferOperationStatusModal();

  return (
    <Modal.Body className="py-4">
      <div className="form-group">
        <label className="form-label" htmlFor="attendance">
          {t('Status')} <MandatoryField />
        </label>
        <Select
          className="react-select react-select-lg"
          value={data.selectedStatusOption}
          options={data.statusOptions}
          onChange={actions.handleChangeStatusOption}
        />
      </div>
    </Modal.Body>
  );
};

export default EditTradingOfferOperationStatusModalBody;
